class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      const [entry] = entries;
      if (!entry.isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    this.observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 400px 0px',
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  loadRecommendations() {
    const { url } = this.dataset;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('product-recommendations');
        const markup = recommendations?.innerHTML.trim();
        if (markup) {
          this.innerHTML = markup;
        }
      })
      .catch((error) => console.error('Product recommendations failed to load:', error));
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
